import React from 'react';
import styles from "./Logo.module.scss"

const Logo = ({ brand }) =>
    <a href={brand.siteUrl}
        target='_blank'
        rel="noreferrer">
        <img
            src={brand.logoUrl}
            alt={brand.title}
            className={styles.logo}
        />
    </a>


export default Logo;